import { useEffect } from "react";
import api from "../../lib/apiClient";

// XAttributionBeacon — the headless half of the old XLandingFunnel.
// Mounted in AppShell so it fires on EVERY route, not just /. This
// matters now that producers share their PROFILE URL with UTMs
// (e.g. /streettimes?utm_source=x&utm_campaign=first_share&...). The
// landing page may be the profile itself, never the homepage.
//
// Idempotency:
//   - sessionStorage `ge.x_attribution_logged` gates the network call
//     so a route change inside the same tab never re-fires.
//   - The welcome banner on /  still lives in XLandingFunnel — that's
//     a UI concern and only makes sense on the public landing.
const XAttributionBeacon = () => {
  useEffect(() => {
    const sp = new URLSearchParams(window.location.search);
    const utmSource = sp.get("utm_source") || "";
    if (!utmSource || !/^(x|twitter)$/i.test(utmSource)) return;

    const utmCampaign = sp.get("utm_campaign") || "";
    const listSlug = sp.get("list") || "";
    const inv = sp.get("inv") || "";

    try {
      localStorage.setItem("ge.x_utm_source", utmSource);
      if (utmCampaign) localStorage.setItem("ge.x_utm_campaign", utmCampaign);
      if (listSlug) localStorage.setItem("ge.x_list_slug", listSlug);
      if (inv) localStorage.setItem("ge.x_inv", inv);
    } catch { /* private mode — best effort */ }

    if (sessionStorage.getItem("ge.x_attribution_logged")) return;
    sessionStorage.setItem("ge.x_attribution_logged", "1");
    api.post("/x/attribution/log", {
      utm_source: utmSource,
      utm_campaign: utmCampaign || undefined,
      list_slug: listSlug || undefined,
      referrer: document.referrer || undefined,
      landed_at: new Date().toISOString(),
    }).then((r) => {
      const attributionId = r?.data?.attribution_id || "";
      if (attributionId) {
        try { localStorage.setItem("ge.x_attribution_id", attributionId); }
        catch { /* swallow */ }
      }
    }).catch(() => { /* beacon is best-effort */ });
  }, []);

  return null;
};

export default XAttributionBeacon;
